/**
 * DEMO-PREISE für den Live-Preis-Rechner.
 *
 * ↓ Marco / interne Anpassung: nur diese Zahlen ändern, alles andere passt
 *   sich automatisch an.
 *
 * base_chf_per_dm2 — Grundpreis pro dm² veredelter Oberfläche
 * setup_chf        — einmalige Rüstkosten pro Auftrag (Bad-Aufwand)
 * min_stueck_chf   — Mindestpreis pro Stück (kleinste Stückzahl)
 * express_pct      — % Aufschlag für Express (Werktage 3–5)
 * super_pct        — % Aufschlag für Super-Express (24–48 h)
 */
export const PRICING = {
  verzinken:            { label_de: "Verzinken",              label_en: "Zinc plating",           label_fr: "Zingage",                    label_it: "Zincatura",              base_chf_per_dm2: 2.4,  setup_chf: 90,  min_stueck_chf: 1.2 },
  trommelverzinken:     { label_de: "Trommelverzinken",       label_en: "Barrel zinc plating",    label_fr: "Zingage au tonneau",         label_it: "Zincatura a rotobarile", base_chf_per_dm2: 1.9,  setup_chf: 70,  min_stueck_chf: 0.6 },
  "zink-nickel":        { label_de: "Zink-Nickel",            label_en: "Zinc-nickel",            label_fr: "Zinc-nickel",                label_it: "Zinco-nichel",           base_chf_per_dm2: 4.8,  setup_chf: 120, min_stueck_chf: 2.4 },
  "zink-mangan":        { label_de: "Zink-Mangan-Phosphat",   label_en: "Zinc-mn phosphating",    label_fr: "Zinc-manganèse-phosphate",   label_it: "Fosfatazione zinco-manganese", base_chf_per_dm2: 3.2, setup_chf: 100, min_stueck_chf: 1.8 },
  "cns-beizen":         { label_de: "CNS-Beizen",             label_en: "Stainless pickling",     label_fr: "Décapage inox",              label_it: "Decapaggio inox",        base_chf_per_dm2: 3.6,  setup_chf: 110, min_stueck_chf: 2.0 },
  "cns-elektropolieren":{ label_de: "CNS-Elektropolieren",    label_en: "Stainless electropolish",label_fr: "Polissage électrolytique",   label_it: "Elettrolucidatura inox", base_chf_per_dm2: 6.5,  setup_chf: 150, min_stueck_chf: 3.5 },
  "schleifen-buersten": { label_de: "Schleifen · Bürsten",    label_en: "Grinding · brushing",    label_fr: "Meulage · brossage",         label_it: "Levigatura · spazzolatura", base_chf_per_dm2: 5.2, setup_chf: 100, min_stueck_chf: 2.8 },
  bruenieren:           { label_de: "Brünieren",              label_en: "Black-oxide",            label_fr: "Brunissage",                 label_it: "Brunitura",              base_chf_per_dm2: 2.8,  setup_chf: 80,  min_stueck_chf: 1.4 },
  vergolden:            { label_de: "Vergolden",              label_en: "Gold plating",           label_fr: "Dorure",                     label_it: "Doratura",               base_chf_per_dm2: 18.0, setup_chf: 180, min_stueck_chf: 6.5 },
  "chemisch-nickel":    { label_de: "Chemisch-Nickel",        label_en: "Electroless nickel",     label_fr: "Nickelage chimique",         label_it: "Nichel chimico",         base_chf_per_dm2: 7.2,  setup_chf: 140, min_stueck_chf: 3.8 },
  "galvanisch-nickel":  { label_de: "Galvanisch-Nickel",      label_en: "Electrolytic nickel",    label_fr: "Nickelage électrolytique",   label_it: "Nichelatura galvanica",  base_chf_per_dm2: 5.8,  setup_chf: 130, min_stueck_chf: 3.0 },
};

/** Bauteil-Grössenklassen — dm² pro Stück (Erfahrungswerte) */
export const SIZE_CLASSES = {
  micro:  { dm2: 0.15, label_de: "Sehr klein · < 2 cm",     label_en: "Very small · < 2 cm",      label_fr: "Très petit · < 2 cm",   label_it: "Molto piccolo · < 2 cm" },
  small:  { dm2: 0.6,  label_de: "Klein · Kleinteile",       label_en: "Small · fittings",         label_fr: "Petit · quincaillerie", label_it: "Piccolo · minuteria" },
  medium: { dm2: 2.5,  label_de: "Mittel · Handteil",        label_en: "Medium · hand-sized",      label_fr: "Moyen · pièce manuelle", label_it: "Medio · componente manuale" },
  large:  { dm2: 8.0,  label_de: "Gross · Konstruktion",     label_en: "Large · assembly",         label_fr: "Grand · assemblage",     label_it: "Grande · assemblaggio" },
  xl:     { dm2: 25.0, label_de: "Sehr gross · Schweiss-Bau", label_en: "Very large · weldment",   label_fr: "Très grand · soudé",     label_it: "Molto grande · saldato" },
};

/** Mengenrabatt-Staffeln — kumulativ ab dieser Stückzahl */
export const QUANTITY_TIERS = [
  { min: 100,   pct: 5,  label_de: "Ab 100 Stk · –5 %",    label_en: "From 100 pcs · –5%",   label_fr: "Dès 100 pcs · –5%",   label_it: "Da 100 pz · –5%" },
  { min: 500,   pct: 10, label_de: "Ab 500 Stk · –10 %",   label_en: "From 500 pcs · –10%",  label_fr: "Dès 500 pcs · –10%",  label_it: "Da 500 pz · –10%" },
  { min: 2000,  pct: 15, label_de: "Ab 2'000 Stk · –15 %", label_en: "From 2'000 pcs · –15%",label_fr: "Dès 2'000 pcs · –15%",label_it: "Da 2'000 pz · –15%" },
  { min: 10000, pct: 20, label_de: "Ab 10'000 Stk · –20 %",label_en: "From 10'000 pcs · –20%",label_fr: "Dès 10'000 pcs · –20%",label_it: "Da 10'000 pz · –20%" },
];

/** Terminwahl */
export const URGENCY = {
  standard: { pct: 0,  label_de: "Standard · 7–10 Werktage", label_en: "Standard · 7–10 business days", label_fr: "Standard · 7–10 jours ouvrés",    label_it: "Standard · 7–10 giorni lavorativi" },
  express:  { pct: 30, label_de: "Express · 3–5 Werktage",   label_en: "Express · 3–5 business days",   label_fr: "Express · 3–5 jours ouvrés",      label_it: "Express · 3–5 giorni lavorativi" },
  super:    { pct: 60, label_de: "Super-Express · 24–48 h",  label_en: "Super express · 24–48 h",       label_fr: "Super express · 24–48 h",         label_it: "Super-express · 24–48 h" },
};

/**
 * computePrice({ verfahren, size, quantity, urgency })
 *
 * Rechnet einen realistischen Richtpreis-Korridor. Enthält:
 *   • Rüstkostenverteilung
 *   • Stückzahl-Rabatt (kumulativ nach QUANTITY_TIERS)
 *   • Termin-Aufschlag
 *   • ±12 % Bandbreite (Vor/Nach-Toleranz)
 *   • CHF-Betrag pro Stück & für Gesamtauftrag
 *
 * Rückgabe: null wenn Eingaben unvollständig, sonst
 *   { unitPrice, totalPrice, totalPriceMin, totalPriceMax, discount, urgencyPct, tier }
 */
export function computePrice({ verfahren, size, quantity, urgency }) {
  const p = PRICING[verfahren];
  const s = SIZE_CLASSES[size];
  const u = URGENCY[urgency];
  const q = Number(quantity) || 0;
  if (!p || !s || !u || q < 1) return null;

  // 1) Grundpreis pro Stück aus Fläche und Basispreis pro dm²
  const surfacePrice = p.base_chf_per_dm2 * s.dm2;
  // 2) Rüstkosten pro Stück (bei höherer Stückzahl verteilen sich diese)
  const setupPerPiece = p.setup_chf / q;
  // 3) Roh-Stückpreis (vor Rabatt / Aufschlag), aber nicht unter Minimum
  const rawUnit = Math.max(p.min_stueck_chf, surfacePrice + setupPerPiece);

  // 4) Mengenrabatt kumulativ ermitteln
  let tier = null;
  let discountPct = 0;
  for (const t of QUANTITY_TIERS) {
    if (q >= t.min) { tier = t; discountPct = t.pct; }
  }

  // 5) Aufschlag Termin
  const urgencyPct = u.pct;

  // 6) Endpreis pro Stück
  const unit = rawUnit * (1 - discountPct / 100) * (1 + urgencyPct / 100);
  const total = unit * q;

  // 7) Bandbreite ±12 %
  const totalMin = total * 0.88;
  const totalMax = total * 1.12;

  return {
    unitPrice: unit,
    totalPrice: total,
    totalPriceMin: totalMin,
    totalPriceMax: totalMax,
    discount: discountPct,
    urgencyPct,
    tier,
  };
}

/** Locale-Formatter für CHF-Beträge (immer im Schweizer Stil mit Apostroph) */
export function formatCHF(n) {
  if (n == null || Number.isNaN(n)) return "—";
  const rounded = Math.round(n);
  return rounded.toLocaleString("de-CH").replace(/,/g, "'");
}
